import { useEffect, useRef } from 'react';
import type { LottieRefCurrentProps } from 'lottie-react';
import dynamic from 'next/dynamic';
import { importLottie } from './importLottie';
import { useAnimationData } from './useAnimationData';
import { AnimatedImageStyled } from './styled';

const Lottie = dynamic(importLottie, { ssr: false });

const rendererSettings = { preserveAspectRatio: 'xMidYMid slice' };

type AnimatedImageProps = {
  url: string;
  loop?: boolean;
  isPaused?: boolean;
  onComplete?: () => void;
  className?: string;
};

export const AnimatedImage = ({
  url,
  loop = false,
  isPaused = false,
  onComplete,
  className,
}: AnimatedImageProps) => {
  const animationData = useAnimationData(url);
  const lottieRef = useRef<LottieRefCurrentProps | null>(null);

  useEffect(() => {
    if (!lottieRef.current) return;

    if (isPaused) {
      lottieRef.current.pause();
    } else {
      lottieRef.current.play();
    }
  }, [isPaused, animationData]);

  if (!animationData) return null;

  return (
    <AnimatedImageStyled className={className}>
      <Lottie
        animationData={animationData}
        loop={loop}
        autoplay={!isPaused}
        onComplete={onComplete}
        lottieRef={lottieRef}
        rendererSettings={rendererSettings}
      />
    </AnimatedImageStyled>
  );
};
